<template>
  <b-modal :visible="show" @hide="$emit('close')" title="Advanced Filters" size="xl" hide-footer>
    <div class="d-flex justify-content-between filter-modal-body">
      <div class="filter-section pr-3">
        <h6>By Analyst</h6>
        <b-form-group>
          <b-form-checkbox-group v-model="filters.ma" stacked>
            <b-form-checkbox v-for="opt in maOptions" :key="opt.value" :value="opt.value">
              {{ opt.text }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </div>

      <div class="divider"></div>

      <div class="filter-section px-3">
        <h6>By GEO</h6>
        <b-form-group>
          <b-form-checkbox-group v-model="filters.geo" stacked>
            <b-form-checkbox v-for="opt in geoOptions" :key="opt.value" :value="opt.value">
              {{ opt.text }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </div>

      <div class="divider"></div>

      <div class="filter-section pl-3">
        <h6>By OS</h6>
        <b-form-group>
          <b-form-checkbox-group v-model="filters.os" stacked>
            <b-form-checkbox v-for="opt in osOptions" :key="opt.value" :value="opt.value">
              {{ opt.text }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-3">
      <b-button size="sm" variant="secondary" @click="$emit('clear')">Clear All</b-button>
      <b-button size="sm" variant="primary" class="ml-2" @click="$emit('apply', filters)">Apply Filters</b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    show: Boolean,
    maOptions: Array,
    geoOptions: Array,
    osOptions: Array,
    initialFilters: Object
  },
  data() {
    return {
      filters: {
        ma: [],
        geo: [],
        os: []
      }
    }
  },
  watch: {
    show(val) {
    if (val) {
      this.filters = JSON.parse(JSON.stringify(this.initialFilters));
    }
  },
    initialFilters: {
      immediate: true,
      handler(val) {
        if (val) this.filters = JSON.parse(JSON.stringify(val));
      }
    }
  }
}
</script>

<style scoped>
.filter-modal-body {
  min-height: 300px;
}

.filter-section {
  flex: 1;
  overflow-y: auto;
}

.divider {
  width: 1px;
  background-color: #ccc;
  margin: 0 10px;
}
</style>
